import { Partial } from '@40seas/entities/common';
import { CreateEmailDto } from './create.email.dto';

export class UpdateEmailDto extends Partial(CreateEmailDto) {}
